/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  GetProductBasesParams,
  HTTPValidationError,
  ProductBaseCreate,
  ProductBaseRead,
} from "./fastAPI.schemas";

import { customInstance } from "../../axios";
import type { ErrorType } from "../../axios";

/**
 * Route to create a new product_base.
 * @summary Create Product Base
 */
export const createProductBase = (
  productBaseCreate: ProductBaseCreate,
  signal?: AbortSignal,
) => {
  return customInstance<ProductBaseRead>({
    url: `/api/product_base/`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: productBaseCreate,
    signal,
  });
};

export const getCreateProductBaseMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createProductBase>>,
    TError,
    { data: ProductBaseCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createProductBase>>,
  TError,
  { data: ProductBaseCreate },
  TContext
> => {
  const mutationKey = ["createProductBase"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createProductBase>>,
    { data: ProductBaseCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createProductBase(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateProductBaseMutationResult = NonNullable<
  Awaited<ReturnType<typeof createProductBase>>
>;
export type CreateProductBaseMutationBody = ProductBaseCreate;
export type CreateProductBaseMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Create Product Base
 */
export const useCreateProductBase = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createProductBase>>,
      TError,
      { data: ProductBaseCreate },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createProductBase>>,
  TError,
  { data: ProductBaseCreate },
  TContext
> => {
  const mutationOptions = getCreateProductBaseMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to get many product_bases.

Results are paginated.
 * @summary Get Product Bases
 */
export const getProductBases = (
  params?: GetProductBasesParams,
  signal?: AbortSignal,
) => {
  return customInstance<ProductBaseRead[]>({
    url: `/api/product_base/`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetProductBasesQueryKey = (params?: GetProductBasesParams) => {
  return ["api", "product_base", ...(params ? [params] : [])] as const;
};

export const getGetProductBasesQueryOptions = <
  TData = Awaited<ReturnType<typeof getProductBases>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetProductBasesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProductBases>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProductBasesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductBases>>> = ({
    signal,
  }) => getProductBases(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProductBases>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProductBasesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProductBases>>
>;
export type GetProductBasesQueryError = ErrorType<void | HTTPValidationError>;

export function useGetProductBases<
  TData = Awaited<ReturnType<typeof getProductBases>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params: undefined | GetProductBasesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProductBases>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductBases>>,
          TError,
          Awaited<ReturnType<typeof getProductBases>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetProductBases<
  TData = Awaited<ReturnType<typeof getProductBases>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetProductBasesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProductBases>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductBases>>,
          TError,
          Awaited<ReturnType<typeof getProductBases>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetProductBases<
  TData = Awaited<ReturnType<typeof getProductBases>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetProductBasesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProductBases>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Product Bases
 */

export function useGetProductBases<
  TData = Awaited<ReturnType<typeof getProductBases>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetProductBasesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProductBases>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetProductBasesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to check for duplicate product bases.
 * @summary Check Create Product Base
 */
export const checkCreateProductBase = (
  productBaseCreate: ProductBaseCreate,
  signal?: AbortSignal,
) => {
  return customInstance<ProductBaseRead[]>({
    url: `/api/product_base/check-create`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: productBaseCreate,
    signal,
  });
};

export const getCheckCreateProductBaseMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof checkCreateProductBase>>,
    TError,
    { data: ProductBaseCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof checkCreateProductBase>>,
  TError,
  { data: ProductBaseCreate },
  TContext
> => {
  const mutationKey = ["checkCreateProductBase"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof checkCreateProductBase>>,
    { data: ProductBaseCreate }
  > = (props) => {
    const { data } = props ?? {};

    return checkCreateProductBase(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CheckCreateProductBaseMutationResult = NonNullable<
  Awaited<ReturnType<typeof checkCreateProductBase>>
>;
export type CheckCreateProductBaseMutationBody = ProductBaseCreate;
export type CheckCreateProductBaseMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Check Create Product Base
 */
export const useCheckCreateProductBase = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof checkCreateProductBase>>,
      TError,
      { data: ProductBaseCreate },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof checkCreateProductBase>>,
  TError,
  { data: ProductBaseCreate },
  TContext
> => {
  const mutationOptions = getCheckCreateProductBaseMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to get an product_base by ID.
 * @summary Get Product Base
 */
export const getProductBase = (productBaseId: number, signal?: AbortSignal) => {
  return customInstance<ProductBaseRead>({
    url: `/api/product_base/${productBaseId}`,
    method: "GET",
    signal,
  });
};

export const getGetProductBaseQueryKey = (productBaseId?: number) => {
  return ["api", "product_base", productBaseId] as const;
};

export const getGetProductBaseQueryOptions = <
  TData = Awaited<ReturnType<typeof getProductBase>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  productBaseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProductBase>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetProductBaseQueryKey(productBaseId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductBase>>> = ({
    signal,
  }) => getProductBase(productBaseId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!productBaseId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getProductBase>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProductBaseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProductBase>>
>;
export type GetProductBaseQueryError = ErrorType<void | HTTPValidationError>;

export function useGetProductBase<
  TData = Awaited<ReturnType<typeof getProductBase>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  productBaseId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProductBase>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductBase>>,
          TError,
          Awaited<ReturnType<typeof getProductBase>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetProductBase<
  TData = Awaited<ReturnType<typeof getProductBase>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  productBaseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProductBase>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductBase>>,
          TError,
          Awaited<ReturnType<typeof getProductBase>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetProductBase<
  TData = Awaited<ReturnType<typeof getProductBase>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  productBaseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProductBase>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Product Base
 */

export function useGetProductBase<
  TData = Awaited<ReturnType<typeof getProductBase>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  productBaseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProductBase>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetProductBaseQueryOptions(productBaseId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to update an product_base by ID.
 * @summary Update Product Base
 */
export const updateProductBase = (
  productBaseId: number,
  productBaseCreate: ProductBaseCreate,
) => {
  return customInstance<ProductBaseRead>({
    url: `/api/product_base/${productBaseId}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: productBaseCreate,
  });
};

export const getUpdateProductBaseMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateProductBase>>,
    TError,
    { productBaseId: number; data: ProductBaseCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateProductBase>>,
  TError,
  { productBaseId: number; data: ProductBaseCreate },
  TContext
> => {
  const mutationKey = ["updateProductBase"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateProductBase>>,
    { productBaseId: number; data: ProductBaseCreate }
  > = (props) => {
    const { productBaseId, data } = props ?? {};

    return updateProductBase(productBaseId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateProductBaseMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateProductBase>>
>;
export type UpdateProductBaseMutationBody = ProductBaseCreate;
export type UpdateProductBaseMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Update Product Base
 */
export const useUpdateProductBase = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateProductBase>>,
      TError,
      { productBaseId: number; data: ProductBaseCreate },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateProductBase>>,
  TError,
  { productBaseId: number; data: ProductBaseCreate },
  TContext
> => {
  const mutationOptions = getUpdateProductBaseMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to delete an product_base by ID.
 * @summary Delete Product Base
 */
export const deleteProductBase = (productBaseId: number) => {
  return customInstance<unknown>({
    url: `/api/product_base/${productBaseId}`,
    method: "DELETE",
  });
};

export const getDeleteProductBaseMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteProductBase>>,
    TError,
    { productBaseId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteProductBase>>,
  TError,
  { productBaseId: number },
  TContext
> => {
  const mutationKey = ["deleteProductBase"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteProductBase>>,
    { productBaseId: number }
  > = (props) => {
    const { productBaseId } = props ?? {};

    return deleteProductBase(productBaseId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteProductBaseMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteProductBase>>
>;

export type DeleteProductBaseMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Delete Product Base
 */
export const useDeleteProductBase = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteProductBase>>,
      TError,
      { productBaseId: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteProductBase>>,
  TError,
  { productBaseId: number },
  TContext
> => {
  const mutationOptions = getDeleteProductBaseMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
